export default __webpack_public_path__ + "static/media/flag-marshall-islands.915c3995.svg";